<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Stage and status</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="salesforceStatusValue"
                   let-item>
        <ifb-application-status-icon-chip class="salesforce-status"
                                          [status]="data?.application?.sfAppStatus"></ifb-application-status-icon-chip>
      </ng-template>
      <ng-template horizontalListCustomTemplate="copyOfferLinkAction"
                   let-item>
        <button mat-icon-button
                aria-label="Copy"
                (click)="copy(data?.application?.offerPageUrl)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
